module.exports = __webpack_public_path__ + "files/9a0956d152addfc45b77cb3f667c4108.png";